// extracted by mini-css-extract-plugin
module.exports = {"section":"_31sA1","title":"_3pOLn","list":"EQUOS","listItem":"_3gmCk","fadeIn":"NkC0l","listItemLink":"_3FZgS","readMore":"_37wkj","skeleton":"_1CDYQ","loading":"wFiDv"};